import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.218 3.505a.7.7 0 0 1 0 .99l-16 16a.7.7 0 0 1-.99-.99l16-16a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.315 9.311c0-2.719 2.18-4.911 4.857-4.911 2.133 0 3.952 1.393 4.602 3.335l1.077-1.077C16.86 4.5 14.692 3 12.172 3 8.71 3 5.915 5.832 5.915 9.311v3.741c0 .713-.32 1.385-.868 1.83l-.285.231c-1.35 1.094-.6 3.315 1.162 3.315h.157l1.4-1.4H5.924c-.413 0-.629-.545-.28-.828l.285-.232a3.75 3.75 0 0 0 1.386-2.916zm9.832 4.676a3.75 3.75 0 0 0 1.268 1.981l.286.232c.348.283.133.828-.281.828H9.46l-1.4 1.4h10.36c1.763 0 2.511-2.22 1.163-3.315l-.286-.232a2.36 2.36 0 0 1-.867-1.829v-3.74q-.001-.59-.104-1.15L17.03 9.46v3.593q0 .48.117.935M10.322 19.6a.7.7 0 0 0 0 1.4h3.7a.7.7 0 1 0 0-1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BellAlertOffIcon24.js.map